__turbopack_context__.v({
  "quoteAuthor": "AqXH1G_quoteAuthor",
  "quoteText": "AqXH1G_quoteText",
  "styleQuoteImage": "AqXH1G_styleQuoteImage",
});
